export default [
  {
    id: 'pattern',
    type: 'img',
    src: require('assets/ui/pattern.png'),
  },
  {
    id: 'scene1',
    type: 'img',
    src: require('assets/scenes/Redwoods.jpg'),
  },
  //
  // {
  //   id: 'scene1l0',
  //   type: 'img',
  //   src: require('assets/scenes/layer0.png'),
  // },
  // {
  //   id: 'scene1l1',
  //   type: 'img',
  //   src: require('assets/scenes/layer1.png'),
  // },
  // {
  //   id: 'scene1l2',
  //   type: 'img',
  //   src: require('assets/scenes/layer2.png'),
  // },
  // {
  //   id: 'scene1l3',
  //   type: 'img',
  //   src: require('assets/scenes/layer3.png'),
  // },
  // {
  //   id: 'scene1l4',
  //   type: 'img',
  //   src: require('assets/scenes/layer4.png'),
  // },
  // {
  //   id: 'scene1l5',
  //   type: 'img',
  //   src: require('assets/scenes/layer5.png'),
  // },
  // {
  //   id: 'scene1l6',
  //   type: 'img',
  //   src: require('assets/scenes/layer6.jpg'),
  // },

  {
    id: 'scene1d',
    type: 'img',
    src: require('assets/scenes/Redwoods National Park depth.jpg'),
  },
  {
    id: 'scene2',
    type: 'img',
    src: require('assets/scenes/Yosemite.jpg'),
  },
  {
    id: 'scene3',
    type: 'img',
    src: require('assets/scenes/Sanbabara.jpg'),
  },
  {
    id: 'scene4',
    type: 'img',
    src: require('assets/scenes/MontereyBay.jpg'),
  },
  {
    id: 'scene5',
    type: 'img',
    src: require('assets/scenes/LaJolla.jpg'),
  },




  {
    id: 'scene2d',
    type: 'img',
    src: require('assets/scenes/Yosemite National Park depth5.jpg'),
  },
  {
    id: 'scene3d',
    type: 'img',
    src: require('assets/scenes/Santa Barbara depth.jpg'),
  },
  {
    id: 'scene4d',
    type: 'img',
    src: require('assets/scenes/Monterey Bay Aquarium depth.jpg'),
  },

  {
    id: 'scene5d',
    type: 'img',
    src: require('assets/scenes/La Jolla beach depth2.jpg'),
  },
  {
    id: 'scene5tex',
    type: 'img',
    src: require('assets/scenes/scene5.png')
  },
  {
    id: 'scene5atlas',
    type: 'other',
    src: require('assets/scenes/scene5.atlas')
  },
  {
    id: 'scene5json',
    type: 'other',
    src: require('assets/scenes/scene5.txt')
  },
  {
    id: 'scene3tex',
    type: 'img',
    src: require('assets/scenes/scene3.png')
  },
  {
    id: 'scene3atlas',
    type: 'other',
    src: require('assets/scenes/scene3.atlas')
  },
  {
    id: 'scene3json',
    type: 'other',
    src: require('assets/scenes/scene3.txt')
  },
  {
    id: 'scene1tex',
    type: 'img',
    src: require('assets/scenes/scene1.png')
  },
  {
    id: 'scene1atlas',
    type: 'other',
    src: require('assets/scenes/scene1.atlas')
  },
  {
    id: 'scene1json',
    type: 'other',
    src: require('assets/scenes/scene1.txt')
  },
  {
    id: 'scene2tex',
    type: 'img',
    src: require('assets/scenes/scene2.png')
  },
  {
    id: 'scene2atlas',
    type: 'other',
    src: require('assets/scenes/scene2.atlas')
  },
  {
    id: 'scene2json',
    type: 'other',
    src: require('assets/scenes/scene2.txt')
  },
  {
    id: 'scene4tex',
    type: 'img',
    src: require('assets/scenes/scene4.png')
  },
  {
    id: 'scene4atlas',
    type: 'other',
    src: require('assets/scenes/scene4.atlas')
  },
  {
    id: 'scene4json',
    type: 'other',
    src: require('assets/scenes/scene4.txt')
  },

]
